import {
  StatusCardHeaderFrame,
  StatusCardInfoFrame,
  StatusCardInnerFrame,
  StatusCardPercentage,
  StatusCardHeaderText,
  StatusCardAverageText,
  StatusCardAverageLableText,
  StatusCardInfoIconButton,
  StatusCardMainWrapper,
  StatusCardIcon,
} from './styles'
import getAnalyticDescription from '../../../utils/monitoringDescriptions'
import { makePublicUrl } from 'app/utils/publicUrl'

interface StatusCardProps {
  data: number
  title: string
}

function StatusCard({ data, title }: StatusCardProps) {
  const getStatusBGColor = (average: number) => {
    if (average >= 90) {
      return { background: '#f4fcf3', font: '#23C514' }
    }
    if (average < 90 && average > 50) {
      return { background: 'rgba(243, 223, 45, 0.07)', font: '#F3DF2D' }
    }
    if (average === 0) {
      return { background: '#ebecf0', font: '#000000' }
    } else {
      return { background: 'rgba(219, 84, 42, 0.1)', font: '#C5292A' }
    }
  }

  const avg = Math.round(data)
  let color = getStatusBGColor(avg)

  return (
    <StatusCardMainWrapper style={{ background: color.background }}>
      <StatusCardInnerFrame>
        <StatusCardInfoFrame>
          <StatusCardHeaderFrame>
            <StatusCardHeaderText>{title}</StatusCardHeaderText>
            <StatusCardInfoIconButton title={getAnalyticDescription(title)}>
              <StatusCardIcon
                src={makePublicUrl(`images/networkIcons/info.svg`)}
              />
            </StatusCardInfoIconButton>
          </StatusCardHeaderFrame>
          <StatusCardPercentage>
            <StatusCardAverageText style={{ color: color.font }}>
              {avg}
            </StatusCardAverageText>
            <div>
              <StatusCardAverageLableText style={{ color: color.font }}>
                %
              </StatusCardAverageLableText>
            </div>
          </StatusCardPercentage>
        </StatusCardInfoFrame>
      </StatusCardInnerFrame>
    </StatusCardMainWrapper>
  )
}

export default StatusCard
